<template lang="pug"></template>

<script>
export default {
    name: 'BotaoNoticias',
    componentOptions: {
        title: 'Noticias',
        actions: [
            [
                {
                    name: 'Noticías',
                    iconClass: 'lyra-icon lyra-newspaper-icon',
                    showView: false,
                    action: 'abrirNoticias',
                    route: 'Noticias'
                }
            ]
        ]
    },

    methods: {
        abrirNoticias() {
            if (this.$route.name !== 'Noticia') {
                this.$router.push({ name: 'Noticia' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
